/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import styles from "ui/feature/root/common/PageOverlayLoading.module.scss";
import IconOverlay from "ui/feature/root/common/IconOverlay";
import Body from "ui/kit/typography/Body";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRotate} from "@fortawesome/free-solid-svg-icons";

const PageOverlayLoading: React.FC = () => {
    return (
        <div className={styles.loadingContainer}>
            <IconOverlay mode={"in_progress"}>
                <FontAwesomeIcon icon={faRotate} size={"3x"}/>
            </IconOverlay>
            <Body className={styles.loadingText}>Analyzing... This may take a few minutes.</Body>
        </div>
    )
}

export default PageOverlayLoading;